import React, { useState } from "react";
import style from "./OurBlogs.module.css";
import { blogSearchButton } from "../../assets";
import Header from "../../components/Header";
import HeaderMobile from "../../components/HeaderMobile";
import BlogCard from "../../components/BlogCard";
import { Link, Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getBlogsList } from "../../api/containersApi";
import truncateIfLong1 from "../../utilities/truncateIfLong1";
import truncateIfLong2 from "../../utilities/truncateIfLong2";
import { ClipLoader } from 'react-spinners'

export default function OurBlogs(){

    const [paginationObject, setPagintaionObject] = useState({
        "limit":21,
        "pageNumber": 1,
        "keyword": "",   
    });

    const { data: blogList, isLoading, isPending, isError, refetch } = useQuery({
        queryKey: ["blogList"],
        queryFn: () => (getBlogsList({auth_key: localStorage.getItem("sessionToken"), bodyData: paginationObject})),
    });
    
    const searchBlogsHandler = (e) => {

        e.preventDefault();
        const searchKeyword = e.target.previousElementSibling.value.trim();
        if(searchKeyword.length > 0){
            setPagintaionObject((prev) => ({
                ...prev,
                keyword: searchKeyword,
                pageNumber: 1
            }));
            refetch();
        } else {
            setPagintaionObject((prev) => ({
                ...prev,
                keyword: "",
                pageNumber: 1
            }));
            refetch();
        }        
    }

    return(
        <div className={style.OurBlogs_container}>
            
            <HeaderMobile />

            <div className={style.OurBlogs_Dashboard}>
                
                <Header />
                    {
                        isLoading 
                            ? 
                        // <div style={{color: "white"}}>Loading Blogs...</div> 
                        <div style={{textAlign: "center", color: "white", height: "80vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}><ClipLoader color="#FF9900" size={30} speedMultiplier={0.85}/></div> 
                            :
                        <>    
                            {
                                blogList?.records?.length > 0 ?    
                                <div className={style.blogDescription_dashboard_content}>
                                    <div className={style.imageBox} data-aos="fade-right">
                                        <div style={{backgroundImage: `url(${blogList?.records[0]?.coverImage})`}} className={style.imageBoxBlur}></div>
                                        <img src={blogList?.records[0]?.coverImage} alt="" />
                                    </div>
                                    <div className={style.infoBox} data-aos="fade-left">
                                        <p title={blogList?.records[0]?.blogTitle}>{truncateIfLong1(blogList?.records[0]?.blogTitle, 60)}</p>
                                        <p title={blogList?.records[0]?.authorName}>By <span style={{color: "#FF9900"}}>{blogList?.records[0]?.authorName}</span> | {blogList?.records[0]?.createdAt?.slice(0, blogList?.records[0]?.createdAt?.indexOf(" at"))}</p>
                                        <p className={style.visibleP3} title={blogList?.records[0]?.metaDescription}>{truncateIfLong2(blogList?.records[0]?.metaDescription, 200)}</p>
                                        <Link to={`blog-detail/${blogList?.records[0]?.blogId}`} className={style.ReadMoreLink}><button className={style.ReadMoreButton}>Read More</button></Link>
                                    </div>
                                </div>
                                :
                                <div style={{ color: "white", display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>Stay Tuned! For upcoming Blogs</div>
                            }
                        </>
                    }                    
            </div>

            <div className={style.searchBlogContainer}>            
                <form className={style.searchBlogForm}>
                    <input 
                        type="text" 
                        placeholder="Search Blog" 
                        value={paginationObject?.keyword}
                        onChange={(e) => {
                            setPagintaionObject((prev) => ({
                                ...prev,
                                keyword: e.target.value,
                                pageNumber: 1
                            }));
                        }}
                    />
                    <img 
                        src={blogSearchButton} 
                        alt="Search" 
                        onClick={(e) => {
                            searchBlogsHandler(e);
                        }}
                    />
                </form>
            </div>

            <div className={style.AllBlogs_container}>
                {
                    isLoading ? <div>Loading more...</div> : 
                    blogList?.records?.slice(1)?.map((record) => {
                        return(
                            <BlogCard record={record} makeItSimilarBlog={false} />
                        )
                    })
                }
            </div>
                
        </div>
    );
}